import { enableES5 } from 'immer'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import commonStore from '@/store/commonStore'
import { favoritePageStore } from '@/store/favoritePageStore'
import pageStore from '@/store/pageStore'
import popupStore from '@/store/popupStore'
import promotionStore from '@/store/promotionStore'
import searchStore from '@/store/searchStore'
import soccerDataStore from '@/store/soccerDataStore'
import videoPlayerStore from '@/store/videoPlayerStore'
import { UseStoreType } from '@/types/storeTypes/storeType'

const getTizenPlatformVersion = () => {
  const userAgent = window.navigator.userAgent
  const pattern = /Tizen\s+(\d+\.\d+)/
  const match = userAgent.match(pattern)
  return match ? parseInt(match[1]) : null
}

const getChromeVersion = () => {
  const userAgent = window.navigator.userAgent
  const pattern = /Chrome\/(\d+\.\d+)/
  const match = userAgent.match(pattern)

  return match ? parseInt(match[1]) : null
}

const tizenPlatformVersion = getTizenPlatformVersion()
const chromeVersion = getChromeVersion()

if (
  (tizenPlatformVersion !== null && tizenPlatformVersion < 4) ||
  (chromeVersion !== null && chromeVersion < 56)
) {
  enableES5()
}

const useStore = create<UseStoreType>()(
  devtools(
    immer((...args) => ({
      favoritePage: { ...favoritePageStore(...args) },
      common: { ...commonStore(...args) },
      promotion: { ...promotionStore(...args) },
      player: { ...videoPlayerStore(...args) },
      page: { ...pageStore(...args) },
      popup: { ...popupStore(...args) },
      soccerData: { ...soccerDataStore(...args) },
      search: { ...searchStore(...args) },
    })),
  ),
)

export default useStore
